import React from 'react';

const ANNOUNCEMENTS = [
  'De temps en temps, une surprise vous attend 🎁',
  'Service client : 0708786202 📞',
  'Livraison le même jour sur Ain Aouda 🚚',
  'Paiement à la livraison 💵',
  'Livraison en 1-2 jours partout au Maroc 🚚'
];

const REPEAT_COUNT = 8;

const AnnouncementTicker = () => {
  return (
    <div className="announcement-ticker">
      <div className="announcement-ticker-track">
        {[...Array(REPEAT_COUNT)].map((_, loopIndex) => (
          <React.Fragment key={loopIndex}>
            {ANNOUNCEMENTS.map((text, i) => (
              <React.Fragment key={`${loopIndex}-${i}`}>
                <span className="announcement-item">{text}</span>
                <span className="announcement-dot" aria-hidden="true">•</span>
              </React.Fragment>
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementTicker;
